import * as React from "react";
import { forwardRef } from "react";
const SvgLightning = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" ref={ref} {...props}><path fill="#fff" d="M20.26 2h-8.869L4 12.862h7.391L6.217 23 21 9.966h-6.652L20.26 2Z" /></svg>;
const ForwardRef = forwardRef(SvgLightning);
export default ForwardRef;